import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/global.less';
import "amfe-flexible" // 动态设置根字体大小 ‌:ml-citation{ref="1,3" data="citationList"}
import App from './App.vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router'
import store from './store'
import i18n from './i18n'
import BigNumber from 'bignumber.js'
import VueSeamlessScroll from 'vue-seamless-scroll'


Vue.config.productionTip = false
Vue.prototype.$BigNumber = BigNumber
Vue.prototype.$myI18n = i18n

Vue.use(ElementUI);
Vue.use(VueSeamlessScroll)
Vue.use(Vant);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
